export const useEnv = () => {
  const partnerName = process.env.REACT_APP_PARTNER_NAME;
  const logoUrl = process.env.REACT_APP_DASHBOARD_LOGO_URL;
  const logoFormatType =
    process.env.REACT_APP_DASHBOARD_LOGO_TYPE?.toLowerCase();

  const isResilender = partnerName === "resilender";
  const isResfin = partnerName === "resfin";
  const isLendmarq = partnerName === "lendmarq";
  return {
    partnerName,
    logoUrl,
    logoFormatType,
    isResilender,
    isResfin,
    isLendmarq,
  };
};
